import React, { useRef, useState } from "react";
import NoImage from "../../assets/images/no-image.png";
import { classNames } from "../../helpers/classNames";
import Image from "../elements/Image";
import Button from "./Button";
import Cropper from "react-cropper"; // Cropper.js library for cropping and rotating images
import "cropperjs/dist/cropper.css"; // Import the styles
import Modal from "../elements/Modal";
import CropModal from "../elements/CropModal";
import { Tooltip } from "react-tooltip";

export default function ImageUploadSingle({
  label,
  labelClasses,
  image,
  setImage,
  icon,
  iconClasses,
  title,
  titleClasses,
  noteClasses,
  note,
  dimension,
  removeFile = () => { },
  accepts = "image/jpeg, image/png, image/gif",
  isDisabled = false,
}) {
  const inputRef = useRef();
  const [showCropper, setShowCropper] = useState(false);

  const [originalImage, setOriginalImage] = useState(null);
  const [tempImage, setTempImage] = useState(null);

  const handleFileChange = (e) => {
    if (isDisabled) return;
    const file = e.target.files[0];
    if (
      file &&
      ["jpg", "jpeg", "png", "gif"].includes(file.type.split("/")[1])
    ) {
      setImage(file);
      setOriginalImage(URL.createObjectURL(file));
      setTempImage(URL.createObjectURL(file));
    } else {
      alert("Please upload a valid image file.");
    }
  };

  return (
    <>
      <div className="relative">
        <div className="w-full relative space-y-1">
          {label && (
            <div
              className={classNames(
                "text-sm font-semibold text-slate-500 tracking-none",
                labelClasses
              )}
            >
              {label}
            </div>
          )}
          {image ? (
            <div className="relative h-48 w-full aspect-square rounded-md border border-slate-100 dark:border-slate-700 flex group">
              {!isDisabled && (
                <div className="opacity-0 invisible transition-all duration-200 group-hover:opacity-100 group-hover:visible">
                  <Button
                    buttonIcon={"fa-light fa-xmark"}
                    buttonIconPosition={"left"}
                    buttonClasses={classNames(
                      "!absolute !w-5 !h-5 !p-0 !justify-center -top-2 -right-1 !text-xs !bg-red-500 !border-none !text-white !rounded-full"
                    )}
                    buttonFunction={() => {
                      setImage(null);
                      removeFile(image);
                    }}
                  />
                </div>
              )}
              <div
                className="w-full h-full overflow-hidden rounded-md cursor-pointer"
                data-tooltip-id="crop-images"
                onClick={() => {
                  setTempImage(
                    image instanceof File ? URL.createObjectURL(image) : image
                  );
                  setShowCropper(true);
                }}
              >
                <Image
                  alt=""
                  width={200}
                  height={200}
                  className="h-full w-full object-contain"
                  src={
                    image instanceof File
                      ? URL.createObjectURL(image)
                      : image || NoImage
                  }
                />
                <Tooltip
                  id="crop-images"
                  place="bottom"
                  className="!text-slate-500 dark:!text-slate-200 !text-sm !bg-slate-950 dark:!bg-slate-400 !bg-opacity-100 z-100"
                  render={() => (
                    <div className="text-white">
                      Click to crop images.
                    </div>
                  )}
                />
              </div>
            </div>
          ) : (
            <div className="h-48 w-full relative bg-white dark:bg-slate-700 border-2 items-center rounded-lg cursor-pointer border-slate-200 dark:border-slate-600 border-dashed">
              <input
                ref={inputRef}
                type="file"
                accept={accepts}
                onChange={handleFileChange}
                className="h-full w-full opacity-0 z-10 absolute cursor-pointer"
                disabled={isDisabled}
              />
              <div className="h-full w-full absolute z-1 flex justify-center items-center top-0 p-4 text-center">
                <div className="flex flex-col space-y-1">
                  {icon && (
                    <div
                      className={classNames(
                        "text-slate-300 text-4xl text-center",
                        iconClasses
                      )}
                    >
                      <i className={classNames("fa-fw", icon)}></i>
                    </div>
                  )}
                  <div
                    className={classNames(
                      "text-base font-bold text-slate-500 dark:text-slate-400",
                      titleClasses
                    )}
                  >
                    {title}
                  </div>
                  <div
                    className={classNames(
                      "text-xs text-slate-400 dark:text-slate-500 text-center",
                      noteClasses
                    )}
                  >
                    {note}
                  </div>
                  <div
                    className={classNames(
                      "text-xs text-slate-400 dark:text-slate-500 text-center",
                      noteClasses
                    )}
                  >
                    {dimension}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showCropper && (
        <>
          <CropModal
            image={image}
            setImage={setImage}
            originalImage={originalImage}
            setOriginalImage={setOriginalImage}
            tempImage={tempImage}
            setTempImage={setTempImage}
            showCropper={showCropper}
            setShowCropper={setShowCropper}
          />
        </>
      )}
    </>
  );
}
